export {}

const initPosts = () => {
  document.querySelectorAll(".i-post:not(.--initialized").forEach((post) => {
    const tagsOpen = post.querySelector(".i-post__tags-expand")
    const tagsClose = post.querySelector(".i-post__tags-close")
    const tags = post.querySelector(".i-post__tags")

    const handleOpenTags = () => {
      tagsOpen?.classList.add("--hide")
      tags?.classList.add("--open")
    }

    const handleCloseTags = () => {
      tagsOpen?.classList.remove("--hide")
      tags?.classList.remove("--open")
    }

    tagsOpen?.addEventListener("click", handleOpenTags)
    tagsClose?.addEventListener("click", handleCloseTags)

    post.classList.add("--initialized")
  })
}

initPosts()

document.addEventListener("postsReinit", initPosts)
